import {Platform, Text} from 'react-native';
import {FontIcon, SimpleFontIcon} from './FontIcon';
import {getDevice} from '../../services/utility';
import {
  Button,
  chooseTheme,
  CommonButtonTextStyleAndroid,
  CommonButtonTextStyleWeb,
  CommonButtonTextStyleWebPhone,
} from './button';
import vars from '../root';
import {styles} from './styles.js';
import {Link} from 'react-router-dom';
import {useTheme} from 'styled-components';

const CommonButton = props => {
  const theme = useTheme();
  let allStyles = props.style ? props.style : {...styles.flexEnd};

  const className = `myBtn${
    props.theme === 'transparent' ||
    props.varient === 'outline' ||
    props.varient === 'text'
      ? '-Transparent'
      : ''
  } ${theme.name === 'dark' ? 'myBtn-dark' : ''} ${
    !props.style || !props.style.justifyContent ? 'flex-end' : ''
  }`;

  const isInWebPhone =
    Platform.OS === 'web' && getDevice().indexOf('WebPort') !== -1;

  let textStyle =
    Platform.OS === 'web'
      ? isInWebPhone
        ? CommonButtonTextStyleWebPhone
        : CommonButtonTextStyleWeb
      : CommonButtonTextStyleAndroid;

  if (props.textStyle !== undefined)
    textStyle = {
      ...textStyle,
      ...props.textStyle,
    };

  const themeRes = chooseTheme(
    props.theme ? props.theme : 'yellow',
    allStyles,
    textStyle,
    theme,
    props.varient,
  );
  allStyles = themeRes[0];
  textStyle = themeRes[1];

  allStyles.alignSelf =
    props.dir && props.dir === 'rtl' ? 'flex-start' : 'flex-end';
  const hrefStyle = {textDecoration: 'none'};
  if (!props.href) {
    allStyles.padding =
      props.padding && props.padding === 'unset'
        ? isInWebPhone
          ? 5
          : '9px 15px'
        : props.padding
        ? props.padding
        : isInWebPhone
        ? 5
        : '5px 30px';
  } else {
    // allStyles.padding = '5px 0';
    // hrefStyle.padding =
    //   props.padding !== undefined && props.padding === 'unset'
    //     ? isInWebPhone
    //       ? '5px 5px'
    //       : '9px 15px'
    //     : isInWebPhone
    //     ? 5
    //     : '5px 30px';
  }

  if (props.icon) {
    allStyles.display = 'flex';
    allStyles.alignItems = 'center';
    allStyles.justifyContent = 'space-around';
  }

  return Platform.OS === 'android' || Platform.OS === 'ios' ? (
    <Button style={allStyles} onPress={props.onPress}>
      <Text style={textStyle}>{props.title}</Text>
    </Button>
  ) : props.href ? (
    <Button style={allStyles}>
      <Link to={props.href ? props.href : '/'} style={hrefStyle}>
        <Text style={textStyle}>{props.title}</Text>
      </Link>
    </Button>
  ) : (
    <div className={className}>
      <Button
        disabled={props.disabled}
        style={allStyles}
        onClick={props.onPress}>
        {props.icon !== undefined &&
          (props.iconDir === undefined || props.iconDir === 'right') && (
            <SimpleFontIcon
              kind={'normal'}
              style={{color: vars.WHITE}}
              icon={props.icon}
              onPress={props.onPress}
            />
          )}
        <Text style={textStyle}>{props.title}</Text>
        {props.icon &&
          props.iconDir &&
          props.iconTheme === undefined &&
          props.iconDir === 'left' && (
            <SimpleFontIcon
              kind={'normal'}
              style={{color: vars.WHITE}}
              icon={props.icon}
              onPress={props.onPress}
            />
          )}
        {props.icon &&
          props.iconDir &&
          props.iconTheme &&
          props.iconDir === 'left' && (
            <FontIcon
              kind={'small'}
              icon={props.icon}
              onPress={props.onPress}
            />
          )}
      </Button>
    </div>
  );
};

export default CommonButton;
